import {generateShareId} from "./utils";
import {uploadJsonFileAPI} from "../API/KB/KBAPI";
import {puppeteerCreateShareChatScreenshot} from "../API/puppeteerAPI";
import {Backdrop, Button, Fade, IconButton, Modal, Paper, TextField, Typography} from "@mui/material";
import {colorSecondary} from "../App/theme";
import CloseIcon from "@mui/icons-material/Close";
import React from "react";
import {getAccountId} from "../API/User";
import {kbUserDataLoaded} from "../utils";

const fetchOGImage = async (url) => {
    try {
        const response = await fetch(url);
        // Use a proxy here to bypass CORS issues.
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const metaTag = doc.querySelector('meta[property="og:image"]');
        if (metaTag) {
            return metaTag.getAttribute('content');
        }
    } catch (error) {
        console.error("Error fetching OG image:", error);
    }
    return null;
};

export const ShareChatDialog = ({shareDetails, ogImage, setShareDetails}) => {

    const handleClose = () => {
        setShareDetails(null);
    };


    return (
        <Modal
            open={!!shareDetails}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={!!shareDetails}>
                <Paper elevation={3} style={{marginTop: '20px', padding: '20px', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>

                    {/* Close Button */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Typography variant="h6" style={{ color: colorSecondary, fontWeight: 'bold' }}>
                            Grab & Share Your Chat Magic!
                        </Typography>
                        <IconButton edge="end" color="inherit" onClick={handleClose} >
                            <CloseIcon />
                        </IconButton>
                    </div>

                    <TextField
                        multiline
                        rows={8}
                        fullWidth
                        label="Awesome post"
                        variant="outlined"
                        margin="normal"
                        value={shareDetails.url + '\n\n' + shareDetails.summary}
                    />

                    {
                        ogImage &&
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px', marginBottom: '15px' }}>
                            <img src={ogImage} alt="Shared content preview" style={{ maxWidth: '100%', maxHeight: '100%' }} />
                        </div>
                    }


                    {/* OK Button container */}
                    <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', marginTop: '15px' }}>
                        <Button onClick={() => navigator.clipboard.writeText(shareDetails.url + '\n\n' + shareDetails.summary)} style={{marginRight: '10px'}}>
                            Copy
                        </Button>
                        <Button
                            color="primary"
                            onClick={handleClose}
                        >
                            Close
                        </Button>
                    </div>
                </Paper>
            </Fade>
        </Modal>
    )
}

export const handleShare = async ({messagesToShare, avatars, KBId, setLoading, setOgImage, setShareDetails}) => {
    setLoading('Creating shared chat...');

    const accountId = await getAccountId();

    if (!accountId) return;

    const url = `${window.location?.origin}/share-chat/${KBId}/${generateShareId(JSON.stringify({
        messagesToShare,
        avatars
    }))}?id=${accountId}`;

    if (!messagesToShare.length) return;

    const JSONString = JSON.stringify({messagesToShare, avatars});
    const shareId = generateShareId(JSONString);

    try {
        await uploadJsonFileAPI(JSONString, shareId + '.json', (data) => {});
        await puppeteerCreateShareChatScreenshot(KBId, shareId);
        
        const imageUrl = await fetchOGImage(url);
        setShareDetails({
            url: url,
            summary: 'Shared chat conversation'
        });
        setOgImage(imageUrl);
        setLoading(false);
    } catch (error) {
        console.error("Error:", error);
        setLoading(false);
    }
}

export const createHandleMessageAddReaction = ({activeEmojiMenu, chatMessageAddReaction, chatId, setMessages, setActiveEmojiMenu}) => {
    return (emoji) => {
        const userId = kbUserDataLoaded?.myUserId;
        const msgId = activeEmojiMenu;
        const {id, name, native} = emoji;

        chatMessageAddReaction(chatId, msgId, id);

        setMessages(prevMessages => prevMessages.map(message => {
            if (message.msgId === msgId) {
                const reactions = message.reactions || {};
                const emojiReactions = reactions[id] || {};
                emojiReactions[userId] = true;
                return { ...message, reactions: { ...reactions, [id]: emojiReactions } };
            }
            return message;
        }));

        setActiveEmojiMenu(null)
    }
}